<template>
    <div class="specs-tabs pfm-active">
        <div class="tab-nav">
            <ul class="flex items-center xl:flex-no-wrap xl:flex-row md:flex-wrap md:flex-col">
                <li class="btn1 flex-1 md:w-full mb-2 xl:mr-spc6 md:mr-0">
                    <a class="default-btn w-full template-btn py-1 px-10 text-white border-white opacity-50 hover:opacity-100 hover:text-white" href="#">
                        Performance
                    </a>
                </li>
                <li class="btn2 flex-1 md:w-full mb-2">
                    <a class="default-btn w-full template-btn py-1 px-10 text-white border-white opacity-50 hover:opacity-100 hover:text-white" href="#">
                        Long Range Plus
                    </a>
                </li>
            </ul>
        </div>

        <div class="tab-body relative">
            <div class="tab-item tab-1 flex items-start">
                <ul class="left-list w-2/4">
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Battery
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            Long Range
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Acceleration
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            2.6s 0-60 mph
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Range
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            305 miles (EPA est.)
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Drive
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            All-Wheel Drive
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Seating
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            Up to 7 Adults
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Wheels
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            20” or 22”
                        </span>
                    </li>
                </ul>

                <ul class="right-list w-2/4">
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Weight
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            5,531 lbs
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Cargo
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            88 cu ft
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Displays
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            Driver Display + 17" Touchscreen
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Supercharging Max/Payment Type
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            200 kW max; Free Supercharging
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Onboard Charger Max
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            11.5 kW max (48A)
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Warranty
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            Basic Vehicle - 4 years or 50,000 miles, whichever comes first <br>
                    Battery & Drive unit - 8 years or 150,000 miles, whichever comes first
                        </span>
                    </li>
                </ul>
            </div>

            <div class="tab-item tab-2 flex items-start">
                <ul class="left-list w-2/4">
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Battery
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            Long Range
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Acceleration
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            4.4s 0-60 mph
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Range
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            351 miles (EPA est.)
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Drive
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            All-Wheel Drive
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Seating
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            Up to 7 Adults
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Wheels
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            20” or 22”
                        </span>
                    </li>
                </ul>

                <ul class="right-list w-2/4">
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Weight
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            5,421 lbs
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Cargo
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            88 cu ft
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Displays
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            Driver Display + 17" Touchscreen
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Supercharging Max/Payment Type
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            200 kW max; Free Supercharging
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Onboard Charger Max
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            11.5 kW max (48A)
                        </span>
                    </li>
                    <li class="mb-space2 pb-spc6 pr-space2 relative">
                        <span class="title block text-white leading-spc5 font-semibold text-14">
                            Warranty
                        </span>
                        <span class="stitle block text-white leading-spc5 font-normal text-14">
                            Basic Vehicle - 4 years or 50,000 miles, whichever comes first <br>
                    Battery & Drive unit - 8 years or 150,000 miles, whichever comes first
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';

    export default {
        name: "SpecsTab",
        mounted() {
            $(document).on('click', '.specs-tabs .tab-nav ul li', function (e) {
                e.preventDefault();
                $('.specs-tabs').addClass('pfm-active').removeClass('lrp-active');
            });
            $(document).on('click', '.specs-tabs .tab-nav ul li:last-child', function (e) {
                e.preventDefault();
                $('.specs-tabs').removeClass('pfm-active').addClass('lrp-active');
            });
        }
    }
</script>

<style scoped>

</style>